import { useEffect, useId } from 'react';

import { useAgentContext } from './AgentContextProvider';
import type { AgentContextSubject } from './types';

/**
 * Declares that the data this component renders belongs to `subject` rather than to the
 * signed-in user.
 */
export const useRegisterAgentSubject = (subject: AgentContextSubject | null) => {
  const ctx = useAgentContext();
  const id = useId();

  // Deliberately no dep array: a cleanup on re-render would drop the subject mid-commit.
  useEffect(() => {
    if (subject) ctx?.registerSubject(id, subject);
    else ctx?.unregisterSubject(id);
  });

  useEffect(() => () => ctx?.unregisterSubject(id), [ctx, id]);
};
